// 9fbef606107a605d69c0edbcd8029e5d
/**
 * These are temporary changes for a dummy Bag page
 */

const FIELDS_FOR_PRODUCT_TRANSLATION = `v_tcpfit,v_tcpsize,v_item_catentry_id,productid,prodpartno,seo_token,TCPStyleQTYUS,TCPStyleQTYCA,
 TCPStyleTypeUS,TCPStyleTypeCA,TCPProductIndUSStore,TCPProductIndCanadaStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,variantId,
 giftcard,TCPFit,product_name,TCPColor,auxdescription,imagename,favoritedcount,product_short_description,style_long_description,min_list_price,
 min_offer_price,product_long_description`;

const FIELDS_FOR_PROD_DETAILS = `alt_img,style_partno,giftcard,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,
 TCPFitMessageUSSstore,TCPFit,product_name,TCPColor,top_rated,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,
 categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,
 product_long_description,seo_token,variantCount,prodpartno,variants,v_tcpfit,v_qty,v_tcpsize,style_name,v_item_catentry_id,v_listprice,v_offerprice,
 v_qty,variantId,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,v_variant,
 %20low_offer_price,%20high_offer_price,%20low_list_price,%20high_list_price,long_product_title,TCPMultiPackUSStore,isVMPEnabled,TCPProductIndCanadaStore,
 TCPProductIndUSStore,TCPStyleTypeCA,TCPStyleTypeUS,TCPStyleQTYUS,TCPStyleQTYCA,TCPMultiPackReferenceUSStore&uid=uid-1562746344280-64813`;

const CARTPAGE_CONSTANTS = {
  REMOVE_CART_ITEM: 'REMOVE_CART_ITEM',
  CONFIRM_REMOVE_CART_ITEM: 'CONFIRM_REMOVE_CART_ITEM',
  UPDATE_CART_ITEM: 'UPDATE_CART_ITEM',
  REMOVE_CART_ITEM_COMPLETE: 'REMOVE_CART_ITEM_COMPLETE',
  UPDATE_CART_ITEM_COMPLETE: 'UPDATE_CART_ITEM_COMPLETE',
  SET_TOGGLE_CART_ITEM_ERROR: 'SET_TOGGLE_CART_ITEM_ERROR',
  CLEAR_TOGGLE_CART_ITEM_ERROR: 'CLEAR_TOGGLE_CART_ITEM_ERROR',
  SET_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR: 'SET_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR',
  CLEAR_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR: 'CLEAR_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR',
  SCROLL_TO_TILE: 'SCROLL_TO_TILE',
  GET_PRODUCT_SKU_INFO: 'GET_PRODUCT_SKU_INFO',
  GET_PRODUCT_SKU_INFO_SUCCESS: 'GET_PRODUCT_SKU_INFO_SUCCESS',
  AVAILABILITY_OK: 'OK',
  AVAILABILITY_SOLDOUT: 'SOLDOUT',
  AVAILABILITY_UNAVAILABLE: 'UNAVAILABLE',
  AVAILABILITY_SUGGESTED: 'SUGGESTED',
  AVAILABILITY: {
    OK: 'OK',
    SOLDOUT: 'SOLDOUT',
    UNAVAILABLE: 'UNAVAILABLE',
    REQ_QTY_UNAVAILABLE: 'REQ_QTY_UNAVAILABLE',
    BOSSINELIGIBLE: 'BOSSINELIGIBLE',
    SUGGESTED: 'SUGGESTED',
  },
  BOSS: 'BOSS',
  PURE_BOSS: 'PURE_BOSS',
  PURE_BOPIS: 'PURE_BOPIS',
  BOPIS: 'BOPIS',
  PICKUP_MODAL_OPEN_FROM_BAG: 'PICKUP_MODAL_OPEN_FROM_BAG',
  ECOM: 'ECOM', // REVIEW: we need it to control an state to favorite's item (favorites' page).
  PURE_ECOM: 'PURE_ECOM',
  BRANDS: {
    TCP: 'TCP',
    GYM: 'GYM',
    SNJ: 'SNJ',
    PJP: 'PJP',
  },
  STORE_SWITCH: {
    OPEN_SELECTION_MODAL: 0,
    AUTO_SWITCH: 1,
    OPEN_RESTRICTED_MODAL: 2,
  },
  CART_ITEM_TILE: 'CartItemTile',
  SET_PRODUCT_MULTIPACK_DATA: 'SET_PRODUCT_MULTIPACK_DATA',
  FIELDS_FOR_PRODUCT_TRANSLATION,
  FIELDS_FOR_PROD_DETAILS,
  CART_LAODINGSTATE: 'CART_LAODINGSTATE',
  CART_TILE_LOADINGSTATE: 'CART_TILE_LOADINGSTATE',
  UPDATE_STORE_ITEM: 'UPDATE_STORE_ITEM',
  STORE_UPDATING_STATE: 'STORE_UPDATING_STATE',
  STORE_UPDATED_COMPLETED_STATE: 'STORE_UPDATED_COMPLETED_STATE',
  HOME: 'home',
  SHIPMENT_PRODUCT_INVENTORY: 'SHIPMENT_PRODUCT_INVENTORY',
  SHIPMENT_PRODUCT_INVENTORY_DETAILS: 'SHIPMENT_PRODUCT_INVENTORY_DETAILS',
  CHECKOUT_IN_PROGRESS: 'CHECKOUT_IN_PROGRESS',
  IS_BACKPACK_ALONE_ERROR: 'IS_BACKPACK_ALONE_ERROR',
  BACKPACK_OOS_ERROR: 'BACKPACK_OOS_ERROR',
  BACKPACK_SFL_CALL: 'BACKPACK_SFL_CALL',
  SET_BOSS_CART_CHECKOUT: 'SET_BOSS_CART_CHECKOUT',
  LOAD_SOCIAL_PROOF_CART_DATA: 'LOAD_SOCIAL_PROOF_CART_DATA',
  PRICE_DROP_NOTIFICATION: 'PRICE_DROP_NOTIFICATION',
};

export const STORE_ERROR = 'User Favorite store not found';

export default CARTPAGE_CONSTANTS;
